import React, {Component} from 'react';
import {Pagination, PaginationItem, PaginationLink } from "reactstrap";

export default class Paginação extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    irPara = (e, index) => {
        e.preventDefault();
        this.controller.paginaAtual = index;
    };

    render() {
        return(
            <div className="pagination-wrapper d-flex justify-content-center">
                <Pagination aria-label="Page navigation">

                    <PaginationItem disabled={this.controller.paginaAtual <= 0}>
                        <PaginationLink
                            onClick={e => this.irPara(e, this.controller.paginaAtual - 1)}
                            previous
                            href="#"
                        />
                    </PaginationItem>

                    {[...Array(this.controller.numeroPaginas )].map((page, i) =>
                        <PaginationItem active={i === this.controller.paginaAtual} key={i}>
                            <PaginationLink onClick={e => this.irPara(e, i)} href="#">
                                {i + 1}
                            </PaginationLink>
                        </PaginationItem>
                    )}

                    <PaginationItem disabled={this.controller.paginaAtual >= this.controller.numeroPaginas - 1}>
                        <PaginationLink
                            onClick={e => this.irPara(e, this.controller.paginaAtual + 1)}
                            next
                            href="#"
                        />
                    </PaginationItem>

                </Pagination>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/Paginação.js